import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleBeginner() {
  const article = seoArticles.find((a) => a.slug === "kakobuy-spreadsheet-dla-poczatkujacych")!;
  return <ArticleLayout article={article} />;
}